import { Card, Typography, Loader, LabelValue, Button, Icon } from '@design-system/index';
import '../../DetailsPage.scss';
import { Grid } from '@design-system/components/Grid/Grid';
import { useDetailsBookingsVM } from './useDetailsBookingsVM';
import { APARTMENT_TYPE } from '@utils/enumTranslation';
import { Tabs } from '@components/Tabs/Tabs';
import { BookingsTabs } from './BookingsTabs';
import { formatMoney } from '@utils/numbers';
import { useNavigate } from 'react-router-dom';
import { ModifierLine } from '@assets/images/icons';

export default function DetailsBookings() {
    const { isLoading, isError, selectedBooking, handleBookingSelect } = useDetailsBookingsVM();

    const navigate = useNavigate();

    if (isLoading) {
        return <Loader className="full-container-loader" />;
    }

    if (isError) {
        return (
            <Typography intrinsic="p" color="secondary">
                Une erreur est survenue lors de la récupération des informations de la fiche logement
            </Typography>
        );
    }

    return (
        <div className="details-apartment-container">
            <div className="details-apartment-container-body">
                <Button variant="primary" color="primary" onClick={() => navigate('/members-management/bookings?action=new')}>
                    Créer une nouvelle réservation
                </Button>
                <Card
                    headerType="very-light"
                    headerTitle={selectedBooking ? 'Réservation sélectionnée' : 'Aucune réservation sélectionnée'}
                    headerStaticAction={
                        selectedBooking && (
                            <Button
                                variant="secondary"
                                onClick={() =>
                                    navigate(
                                        `/members-management/apartments/${selectedBooking.apartment?.id}/bookings/${selectedBooking.id}/edit`
                                    )
                                }
                                icon={<Icon color="primary" icon={<ModifierLine />} size={16} />}
                            >
                                Modifier
                            </Button>
                        )
                    }
                >
                    {selectedBooking && (
                        <Grid columns={3}>
                            <LabelValue label="Nom" value={`${selectedBooking.apartment?.label}`} />
                            <LabelValue label="Type" value={APARTMENT_TYPE[selectedBooking.apartment?.type || 'apartment']} />
                            <LabelValue
                                label="Adresse"
                                value={`${selectedBooking.apartment?.address.city} ${selectedBooking.apartment?.address.zipCode}`}
                            />
                            <LabelValue label="Date d'arrivée" value={new Date(selectedBooking.arrivalDate).toLocaleDateString('fr-FR')} />
                            <LabelValue
                                label="Date de départ"
                                value={new Date(selectedBooking.departureDate).toLocaleDateString('fr-FR')}
                            />
                            <LabelValue label="Prix" value={formatMoney(selectedBooking.rentalPrice)} />
                            <LabelValue label="Dépôt de garantie" value={formatMoney(selectedBooking.depositAmount)} />
                            <LabelValue label="Taxe de séjour" value={formatMoney(selectedBooking.touristTaxAmount)} />
                            <LabelValue label="Caution ménage" value={formatMoney(selectedBooking.cleaningFeeAmount)} />
                            <LabelValue label="Caution annulation" value={formatMoney(selectedBooking.cancellationFeeAmount)} />
                            <LabelValue label="Clés rendues" value={selectedBooking.keysReturned ? 'Oui' : 'Non'} />
                            {selectedBooking.observation && <LabelValue label="Commentaire" value={selectedBooking.observation} />}
                        </Grid>
                    )}
                </Card>

                <Card headerType="none">
                    <Tabs
                        orientation="vertical"
                        tabs={(setActiveTab) => BookingsTabs(setActiveTab, handleBookingSelect)}
                        className="light"
                    />
                </Card>
            </div>
        </div>
    );
}
